<script setup>
import { getI18n } from '@/plugins/i18n'

import { usePlanningStore } from '@/stores/planning.store'
import { useDetectDevice } from '@/composables/device'

import ExpandableContent from '@/components/shared/ExpandableContent.vue'
import FileViewer from '@/components/shared/FileViewer.vue'

const i18n = getI18n()
const planningStore = usePlanningStore()
const { isMobile } = useDetectDevice()

const props = defineProps({
  files: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <q-item>
    <q-item-section>
      <expandable-content :label="i18n.t('common.attachment', props.files.length)" :items="props.files">
        <template #item="{ item }">
          <file-viewer
            :mobile="isMobile"
            hide-delete
            :cell-info="{ value: [item] }"
            @download="async(e) => await planningStore.downloadProjectFileAsync(e.id, e.name)"
          />
        </template>
      </expandable-content>
    </q-item-section>
  </q-item>
</template>
